export default "__VITE_PUBLIC_ASSET__a144ae00__"